export enum StorageKeysEnum {
  jwt = 'jwt',
  i18nextLng = 'i18nextLng',
  tmpToken = 'tmp_token',
  selections = 'selections',
  redirectUrl = 'redirectUrl',
}
